import { ui } from '@wp-g2/styles';
import React from 'react';
import { VStack } from '../VStack';
import { FormGroupContext } from './FormGroup.Context';
import FormGroupHelp from './FormGroupHelp';
import FormGroupLabel from './FormGroupLabel';

function FormGroupContent(_ref) {
  var alignLabel = _ref.alignLabel,
      children = _ref.children,
      help = _ref.help,
      horizontal = _ref.horizontal,
      id = _ref.id,
      _ref$isLabelBlock = _ref.isLabelBlock,
      isLabelBlock = _ref$isLabelBlock === void 0 ? true : _ref$isLabelBlock,
      label = _ref.label,
      labelHidden = _ref.labelHidden,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 2 : _ref$spacing,
      truncate = _ref.truncate;
  var contextProps = React.useMemo(function () {
    return {
      id: id,
      horizontal: horizontal
    };
  }, [id, horizontal]);
  var content = help ? /*#__PURE__*/React.createElement(VStack, Object.assign({
    expanded: false
  }, ui.$('FormGroupContentContainer'), {
    spacing: spacing
  }), children, /*#__PURE__*/React.createElement(FormGroupHelp, null, help)) : children;
  return /*#__PURE__*/React.createElement(FormGroupContext.Provider, {
    value: contextProps
  }, /*#__PURE__*/React.createElement(FormGroupLabel, {
    align: alignLabel,
    id: id,
    isLabelBlock: isLabelBlock,
    labelHidden: labelHidden,
    truncate: truncate
  }, label), content);
}

export default /*#__PURE__*/React.memo(FormGroupContent);